import { breakpointsV2 } from 'spa/config/styled'
import { useWindowWidth } from 'spa/hooks/useWindowWidth'

export const useIsMobile = () => {
  const windowWidth = useWindowWidth()
  return windowWidth < breakpointsV2.tablet
}
